import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import FontIcon from 'components/FontIcon';
import BuildChildren from 'utils/BuildChildren';
import classes from './SiteNavAMobileFlyout.module.scss';

const SiteNavAMobileFlyout = (props) => {
  const { isVisible } = props;
  const overlayClassName = isVisible ? classes.overlayVisible : classes.overlay;
  const containerClassName = isVisible ? classes.containerVisible : classes.container;
  const {
    button,
    items = [],
    onItemClick,
    onOverlayClick,
    onXClick,
  } = props;

  function renderLevelALink(item) {
    return (
      <Link
        href={item.href}
        target={item.target}
        key={item.href}
        className={classes.levelALink}
        onClick={() => { onItemClick(item); }}
        dangerouslySetInnerHTML={{ __html: item.heading }}
      />
    );
  }

  function renderLevelBLinks(bItems = []) {
    return (
      <div>
        <ul className={classes.levelBList}>
          {bItems.filter((i) => i.isVisible).map((item) => (
            <li key={item.href}>
              <Link
                href={item.href}
                target={item.target}
                className={classes.levelBLink}
                onClick={() => { onItemClick(item); }}
                dangerouslySetInnerHTML={{ __html: item.heading }}
              />
            </li>
          ))}
        </ul>
        <hr className={classes.hr} />
      </div>
    );
  }

  return (
    <div>
      <button aria-label='Menu' className={overlayClassName} onClick={onOverlayClick} type='button' />
      <div className={containerClassName}>
        <div className={classes.heading}>
          <button aria-label='Close' className={classes.icon} onClick={onXClick} type='button'>
            <FontIcon icon='far fa-times' />
          </button>
        </div>

        <div className={classes.content}>
          {button.subType && BuildChildren(button)}

          <hr className={classes.hr} />

          {items.filter((i) => i.isVisible).map((item, index) => (
            <div key={`${item}-${index}`}>
              {renderLevelALink(item)}
              {item.isActive && item.items ? renderLevelBLinks(item.items) : null}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

SiteNavAMobileFlyout.propTypes = {
  items: PropTypes.array.isRequired,
  button: PropTypes.object,
  isVisible: PropTypes.bool.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onOverlayClick: PropTypes.func.isRequired,
  onXClick: PropTypes.func.isRequired,
};

export default SiteNavAMobileFlyout;
